import { mapState } from 'vuex'
import routes from '@/router/routes'
import subscribesToOrderUpdatesOnSocket from '@/mixins/subscribesToOrderUpdatesOnSocket'

export default {
  mixins: [subscribesToOrderUpdatesOnSocket],
  data() {
    return {
      fetchedAtLeastOnce: false,
      fetching: false,
      booking: null,
      routes,
      entered: false
    }
  },
  computed: {
    ...mapState({
      navbarLoading: 'navbar_loading'
    }),
    ...mapState('order', {
      orders: 'orders'
    }),
    ...mapState('menu', {
      menu: 'menu'
    }),
    orderToken() {
      return this.booking ? this.booking.order_token : null
    },
    orderLines() {
      return (this.order && this.order.order_lines) || null
    },
    order() {
      return this.orders[this.orderToken] || null
    }
  },
  async created() {
    this.booking = await this.fetchBooking()
  },
  mounted() {
    this.$bus.$on('NAVBAR_PULLED_DOWN', this.fetchBooking)
    this.$bus.$on('APP_DID_BECOME_ACTIVE', this.fetchBooking)
  },
  beforeDestroy() {
    this.$bus.$off('NAVBAR_PULLED_DOWN', this.fetchBooking)
    this.$bus.$off('APP_DID_BECOME_ACTIVE', this.fetchBooking)

    if (this.io) {
      this.io.disconnect()
    }
  },
  methods: {
    afterEnter() {
      this.entered = true
    },
    async fetchBooking() {
      const bookingToken = this.$route.params.bookingToken

      if (this.fetching) {
        return
      }
      try {
        this.fetching = true

        if (this.fetchedAtLeastOnce) {
          this.$store.dispatch('SET_NAVBAR_LOADING_STATUS', true)
        }
        const [booking, order] = await Promise.all([
          this.$store.dispatch('booking/FETCH', bookingToken),
          this.$store.dispatch('booking/FETCH_PREORDERS', bookingToken),
          this.$store.dispatch('menu/FETCH')
        ])
        this.fetchedAtLeastOnce = true

        // If order has been seated, redirect to the table view
        const seated = order && !isNaN(parseInt(order.table_description, 10)) ? true : false

        if (seated) {
          this.$router.push({
            name: this.routes.TABLE_INTRO,
            params: { orderToken: order.token }
          })
          this.$store.dispatch('toast/SUCCESS', 'Bordbestillingen er blevet aktiv.')
          return
        }

        return booking
      } catch (error) {
        this.$store.dispatch('toast/ERROR', error.message)
        this.$router.push({
          name: this.routes.BOOKING
        })
      } finally {
        this.fetching = false
        this.$store.dispatch('SET_NAVBAR_LOADING_STATUS', false)
      }
    }
  }
}
